<div>
  <div class="close-header">
    <img
  src="/assets/images/icons/alert-close.svg"
      class="close-icon"
      alt="close-icon"
      (click)="oncancelClick()"
    />
  </div>
  <div style="margin: 20px">
    <!-- <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="GEOGRAPHY">
        <th mat-header-cell *matHeaderCellDef>Geography</th>
        <td mat-cell *matCellDef="let element">{{ element.GEOGRAPHY }}</td>
      </ng-container>

      <ng-container matColumnDef="CREATED">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let element">{{ element?.SUCCESS }}</td>
      </ng-container>

      <ng-container matColumnDef="UPDATED">
        <th mat-header-cell *matHeaderCellDef>Updated</th>
        <td mat-cell *matCellDef="let element">{{ element?.WARNING }}</td>
      </ng-container>

      <ng-container matColumnDef="DELETED">
        <th mat-header-cell *matHeaderCellDef>Removed</th>
        <td mat-cell *matCellDef="let element">{{ element?.DELETED }}</td>
      </ng-container>

      <ng-container matColumnDef="FAILED">
        <th mat-header-cell *matHeaderCellDef>Failed</th>
        <td mat-cell *matCellDef="let element">{{ element?.FAILURE }}</td>
      </ng-container>

      <ng-container matColumnDef="NOCHANGE">
        <th mat-header-cell *matHeaderCellDef>No Change</th>
        <td mat-cell *matCellDef="let element">{{ element?.NOCHANGE }}</td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        style="background-color: #d3ebff; font: bold 12px 'Unilever Shilling'"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table> -->
    <div style="display: flex; justify-content: flex-start">
      <div class="legend">
        <div class="legend-item">
          <div class="legend-label">Project:</div>
          <div class="legend-text">
            <a href="{{ projectLink }}" class="link-color" target="_blank">{{
              project
            }}</a>
          </div>
        </div>
        <div class="legend-item">
          <div class="legend-label">Product:</div>
          <div class="legend-text">
            <a href="{{ productLink }}" class="link-color" target="_blank">{{
              product
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <table mat-table [dataSource]="dataSource" class="custom-table">
      <!-- Geography Column -->
      <ng-container matColumnDef="GEOGRAPHY">
        <th mat-header-cell *matHeaderCellDef>Geography</th>
        <td mat-cell *matCellDef="let element">{{ element.GEOGRAPHY }}</td>
      </ng-container>

      <!-- Created Column -->
      <ng-container matColumnDef="CREATED">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let element">{{ element.SUCCESS }}</td>
      </ng-container>

      <!-- Updated Column -->
      <ng-container matColumnDef="UPDATED">
        <th mat-header-cell *matHeaderCellDef>Updated</th>
        <td mat-cell *matCellDef="let element">{{ element.WARNING }}</td>
      </ng-container>

      <!-- Removed Column -->
      <ng-container matColumnDef="DELETED">
        <th mat-header-cell *matHeaderCellDef>Removed</th>
        <td mat-cell *matCellDef="let element">{{ element.DELETED }}</td>
      </ng-container>

      <!-- Failed Column -->
      <ng-container matColumnDef="FAILED">
        <th mat-header-cell *matHeaderCellDef>Failed</th>
        <td mat-cell *matCellDef="let element">{{ element.FAILURE }}</td>
      </ng-container>

      <!-- No Change Column -->
      <ng-container matColumnDef="NOCHANGE">
        <th mat-header-cell *matHeaderCellDef>No Change</th>
        <td mat-cell *matCellDef="let element">{{ element.NOCHANGE }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <p style="color: black" *ngIf="isClaimOrderUpdated">
      {{ claimLA }} have been reordered.
    </p>
  </div>
  <!-- <table style="margin-left: 30px; margin-top: 20px">
    <tr>
      <td style="text-align: right">
        <span></span>
        <h5
          class="inline-header"
          style="color: #00a314; font: 16px 'Unilever Shilling'"
        >
          Created :
        </h5>
      </td>
      <td style="text-align: left">
        <span style="font: 14px 'Inter Medium'; color: black"
          >New {{ claimLA }} have been created and added to the project</span
        >
      </td>
    </tr>

    <tr>
      <td style="text-align: right">
        <h5
          class="inline-header"
          style="color: #f5a919; font: 16px 'Unilever Shilling'"
        >
          Updated :
        </h5>
      </td>
      <td style="text-align: left">
        <span style="font: 14px 'Inter Medium'; color: black"
          >New {{ claimLA }} which is a part of the project, have been
          updated</span
        >
      </td>
    </tr>

    <tr>
      <td style="text-align: right">
        <h5
          class="inline-header"
          style="color: #465493; font: 16px 'Unilever Shilling'"
        >
          Removed :
        </h5>
      </td>
      <td style="text-align: left">
        <span style="font: 14px 'Inter Medium'; color: black"
          >New {{ claimLA }} have been removed from the project.</span
        >
      </td>
    </tr>

    <tr>
      <td style="text-align: right">
        <h5
          class="inline-header"
          style="color: #d12a00; font: 16px 'Unilever Shilling'"
        >
          Failed :
        </h5>
      </td>
      <td style="text-align: left">
        <span style="font: 14px 'Inter Medium'; color: black"
          >New {{ claimLA }} records creation failed. If the issue still
          persists, kindly contact your Vault administrator.</span
        >
      </td>
    </tr>

    <tr>
      <td style="text-align: right">
        <h5
          class="inline-header"
          style="color: #44a2df; font: 16px 'Unilever Shilling'"
        >
          No Change :
        </h5>
      </td>
      <td style="text-align: left">
        <span style="font: 14px 'Inter Medium'; color: black">
          No changes have been done to the {{ claimLA }}.</span
        >
      </td>
    </tr>
  </table> -->

  <!-- <div class="legend">
    <div class="legend-item">
      <span class="legend-dot created-dot"></span>
      <strong class="pl-1">Created:</strong>
      <span class="legend-text"
        >New {{ claimLA }} have been created and added to the project.</span
      >
    </div>
    <div class="legend-item">
      <span class="legend-dot updated-dot"></span>
      <strong class="pl-1">Updated:</strong>
      <span class="legend-text"
        >New {{ claimLA }} which are part of the project have been
        updated.</span
      >
    </div>
    <div class="legend-item">
      <span class="legend-dot removed-dot"></span>
      <strong class="pl-1">Removed:</strong>
      <span class="legend-text"
        >New {{ claimLA }} have been removed from the project.</span
      >
    </div>
    <div class="legend-item">
      <span class="legend-dot failed-dot"></span>
      <strong class="pl-1">Failed:</strong>
      <span class="legend-text"
        >New {{ claimLA }} records creation failed. If the issue still persists,
        kindly contact your Vault administrator.</span
      >
    </div>
    <div class="legend-item">
      <span class="legend-dot nochange-dot"></span>
      <strong class="pl-1">No Change:</strong>
      <span class="legend-text"
        >No changes have been done to the {{ claimLA }}.</span
      >
    </div>
  </div> -->

  <!-- <div class="legend">
    <div class="legend-item">
      <span class="legend-dot created-dot"></span>
      <div class="legend-label">
        <span class="label-title">Created </span>
        <span class="label-text"
          >: New {{ claimLA }} have been created and added to the project.</span
        >
      </div>
    </div>

    <div class="legend-item">
      <span class="legend-dot updated-dot"></span>
      <div class="legend-label">
        <span class="label-title">Updated ></span>
        <span class="label-text"
          >: New {{ claimLA }} which are part of the project have been
          updated.</span
        >
      </div>
    </div>

    <div class="legend-item">
      <span class="legend-dot removed-dot"></span>
      <div class="legend-label">
        <span class="label-title">Removed ></span>
        <span class="label-text"
          >: New {{ claimLA }} have been removed from the project.</span
        >
      </div>
    </div>

    <div class="legend-item">
      <span class="legend-dot failed-dot"></span>
      <div class="legend-label">
        <span class="label-title">Failed ></span>
        <span class="label-text"
          >: New {{ claimLA }} records creation failed. If the issue still
          persists, kindly contact your Vault administrator.</span
        >
      </div>
    </div>

    <div class="legend-item">
      <span class="legend-dot nochange-dot"></span>
      <div class="legend-label">
        <span class="label-title">No Change ></span>
        <span class="label-text"
          >: No changes have been done to the {{ claimLA }}.</span
        >
      </div>
    </div>
  </div> -->

  <div class="legend">
    <div class="legend-item">
      <div class="legend-label">Created:</div>
      <div class="legend-text">
        New {{ claimLA }} have been created and added to the project.
      </div>
    </div>
    <div class="legend-item">
      <div class="legend-label">Updated:</div>
      <div class="legend-text">
        New {{ claimLA }} which are part of the project have been updated.
      </div>
    </div>
    <div class="legend-item">
      <div class="legend-label">Removed:</div>
      <div class="legend-text">
        New {{ claimLA }} have been removed from the project.
      </div>
    </div>
    <div class="legend-item">
      <div class="legend-label">Failed:</div>
      <div class="legend-text">
        New {{ claimLA }} records creation failed. If the issue still persists,
        kindly contact your Vault administrator.
      </div>
    </div>
    <div class="legend-item">
      <div class="legend-label">No Change:</div>
      <div class="legend-text">
        No changes have been done to the {{ claimLA }}.
      </div>
    </div>
  </div>

  <div class="actions">
    <span *ngFor="let button of data.buttons">
      <a
        *ngIf="button.id === 'Project' || button.id === 'edit-Project'"
        [href]="
          'https://' + urlDomain + '/ui/#t/0TB000000000733/V2C/' + projectId
        "
        target="_self"
      >
        <button
          mat-raised-button
          style="background-color: #005eea; color: white"
          (click)="navigate(button.id)"
          [title]="button.id === 'edit-Project' ? 'Go to Project Page' : ''"
        >
          {{ button.text }}
        </button>
      </a>

      <button
        *ngIf="button.id === 'Home' || button.id === 'edit-Home'"
        mat-raised-button
        style="background-color: #005eea; color: white; margin-right: 20px"
        (click)="navigate(button.id)"
        [title]="
          button.id === 'edit-Home' ? 'Edit Claims/LAs for another product' : ''
        "
      >
        {{ button.text }}
      </button>
    </span>
  </div>
</div>
